import { ChangeEvent, FC } from 'react';

import {
  useDrawersContext,
  WbDrawer,
  WbDrawerContent,
  WbTabProps,
  WbTabs,
} from '@agilelab/plugin-wb-platform';
import { makeStyles, Typography, Box } from '@material-ui/core';
import PoliciesTab from './Policies/PoliciesTab';
import { PoliciesTabContextProvider } from './Policies/PoliciesTabContext';
import { MetricsTable } from './Metrics/MetricsTable';
import { TabEnum, useFlagAndScoreContext } from '../FlagAndScoreContext';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));

const tabs: WbTabProps[] = [
  {
    name: 'Policies',
  },
  {
    name: 'Metrics',
  },
];

interface DetailDrawerProps {}

export const DetailDrawer: FC<DetailDrawerProps> = ({}) => {
  const classes = useStyles();
  const { toggleBoolean, drawers } = useDrawersContext();
  const { setSelectedTab, selectedTab, metricResults, root, resourceInfo } =
    useFlagAndScoreContext();

  const handleChange = (_: ChangeEvent<{}>, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <WbDrawer
      open={drawers.get(0) ?? false}
      setOpen={() => toggleBoolean(0)}
      title="Test details"
    >
      <WbDrawerContent
        style={{ flex: 1, display: 'flex', flexDirection: 'column' }}
      >
        <Typography variant="h5" style={{ fontWeight: 500 }}>
          {root?.displayName ?? resourceInfo.name}
        </Typography>

        <Box className={classes.container}>
          <WbTabs
            variant="default"
            tabs={tabs}
            tabStyle={{ flexShrink: 0 }}
            handleChange={handleChange}
            selectedTab={selectedTab}
          />

          {selectedTab === TabEnum.Policies && (
            <PoliciesTabContextProvider
              resourceInfoExternalId={resourceInfo.externalId}
            >
              <PoliciesTab />
            </PoliciesTabContextProvider>
          )}
          {selectedTab === TabEnum.Metrics && (
            <MetricsTable metricResults={metricResults ?? []} />
          )}
        </Box>
      </WbDrawerContent>
    </WbDrawer>
  );
};
